import { cn } from '@heidi/utils';

import type { ScrollBarVariant } from './scroll-area.types';

export const scrollAreaRootClasses = cn('relative overflow-hidden');

export const scrollAreaViewportClasses = cn('size-full rounded-[inherit]');

export const scrollBarBaseClasses = cn(
  'flex touch-none select-none transition-opacity duration-200 ease-out data-[state=hidden]:opacity-0 data-[state=visible]:opacity-100'
);

export const scrollBarOrientationClasses = (
  variant: ScrollBarVariant,
  orientation: 'vertical' | 'horizontal'
) =>
  cn(
    variant === 'default' &&
      orientation === 'vertical' &&
      'h-full w-2.5 border-s border-s-transparent p-px',
    variant === 'default' &&
      orientation === 'horizontal' &&
      'h-2.5 flex-col border-t border-t-transparent p-px',
    variant === 'minimal' && orientation === 'vertical' && 'h-full w-1.5',
    variant === 'minimal' && orientation === 'horizontal' && 'h-1.5 flex-col'
  );

export const scrollBarThumbClasses = (variant: ScrollBarVariant) =>
  cn(
    'relative flex-1 rounded-full',
    variant === 'default' && 'bg-background-secondary',
    variant === 'minimal' && 'bg-background-secondary'
  );
